import { load } from "@progress/kendo-react-intl";
import React, { useState, useEffect } from "react";
import BaseMasterGrid from "../BaseMasterGrid";
import CurrencySlider from "./CurrencySlider";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import KendoLoader from "../../KendoLoader";

const CurrencyMaster = () => {
  const defaultEntity = {
    id: 0,
    code: "",
    name: "",
    isActive: true,
    baseCurrency: false,
  };

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [entities, setEntities] = useState([]);
  const [selectedEntity, setSelectedEntity] = useState(defaultEntity);
  const [pageState, setPageState] = useState({ take: 10, skip: 0, total: 0 });
  
  // Custom cell renderer for baseCurrency column
  const BaseCurrencyCell = ({ dataItem }) => {
    const isBaseCurrency = dataItem.baseCurrency;
    
    return (
      <td className="text-center">
        {isBaseCurrency ? (
          <span className="text-green-600 font-bold" aria-label="Base Currency True">✔</span>
        ) : (
          <span className="text-red-600 font-bold" aria-label="Base Currency False">✖</span>
        )}
      </td>
    );
  };

  const gridColumns = [
    { field: "id", title: "ID", hidden: true },
    { field: "code", title: "Code", filterable: true, sortable: true, width: "200px" },
    { field: "name", title: "Name", filterable: true, sortable: true },
    { field: "baseCurrency", title: "Base Currency", cell: BaseCurrencyCell, isBoolean: false  },
    { field: "isActive", title: "Active",  isBoolean: true  },
  ];

  const loadData = async (searchText, state) => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/Currency/getallcurrency?searchText=${searchText}&pageNo=${state.skip}&pageSize=${state.take}`
      );
      setEntities(res.data.data);
      setPageState((prev) => ({
        ...prev,
        total: res.data.totalCount,
        skip: res.data.pageNo,
        take: res.data.pageSize,
        value: searchText,
      }));
    } catch (error) {
      console.error("Error loading currencies:", error);
    } finally {
      setLoading(false);
    }
  };

  const onCreateClick = () => {
    setSelectedEntity(defaultEntity);
    setOpen(true);
  };

  const onEditClick = (e) => {
    setSelectedEntity({ ...e.dataItem });
    setOpen(true);
  };

  const onGridFilter = (e) => {
    let searchText = "~ALL";
    if (e.filter && e.filter.filters && e.filter.filters[0].value !== "") {
      searchText = e.filter.filters[0].value;
    }
    const state = {
      ...pageState,
      filter: { ...e.filter },
      skip: 0,
      value: searchText,
    };
    setPageState(state);
    loadData(searchText, state);
  };

  const onUpdate = (item) => {
    setEntities(entities.map((c) => (c.id === item.id ? { ...item } : c)));
  };

  const onCreate = (item, id) => {
    setEntities([...entities, { ...item, id }]);
  };

  useEffect(() => {
    const searchText = "~ALL";
    loadData(searchText, pageState);
  }, []);

  return (
    <div className="px-4 py-4 sm:px-6 lg:px-8">
      <div className="pb-5 border-b border-gray-200 sm:flex sm:items-center sm:justify-between">
        <h3 className="text-lg leading-6 font-medium text-gray-900">Currency</h3>
        <div className="mt-3 flex sm:mt-0 sm:ml-4">
          <button
            type="button"
            className="ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            onClick={onCreateClick}
          >
            Create
          </button>
        </div>
      </div>
      <div className="flex flex-col">
        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div className="shadow relative overflow-hidden sm:rounded-lg">
              {loading && <KendoLoader />}
              <BaseMasterGrid
                data={entities}
                columns={gridColumns}
                onEditClick={onEditClick}
                setPageState={setPageState}
                loadData={loadData}
                pageState={pageState}
                onGridFilter={onGridFilter}
              />
            </div>
          </div>
        </div>
      </div>
      <CurrencySlider
        open={open}
        setOpen={setOpen}
        onUpdate={onUpdate}
        selectedEntity={selectedEntity}
        setSelectedEntity={setSelectedEntity}
        onCreate={onCreate}
      />
    </div>
  );
};

export default CurrencyMaster;